module.exports = __webpack_public_path__ + "img/dygqk.d76fcffc.png";